module.exports = __webpack_public_path__ + "img/fallback-slide.3840x1280.nl.e371426d.png";